import _isNumber from "lodash/isNumber";
import _isArray from "lodash/isArray";
import _forEach from "lodash/forEach";
import * as requestAnimationFrame from "raf";
export function cancelRaf(rafId) {
    if (_isNumber(rafId)) {
        requestAnimationFrame.cancel(rafId);
    }
    else if (_isArray(rafId)) {
        _forEach(rafId, cancelRaf);
    }
}
export function raf(cb) {
    return requestAnimationFrame.default(cb);
}
export default raf;
export function doubleRaf(cb) {
    const rafIds = [0, 0];
    rafIds[1] = raf(() => {
        rafIds[0] = raf(cb);
    });
    return rafIds;
}
